module.exports = __webpack_public_path__ + "img/default-avatar.8579c46b.png";